/* global jQuery MktoForms2 */

(function ($, MktoForms2) {

	"use strict";

	MktoForms2.onFormRender(function () {
		setTimeout(function(){
			$(".mktoButtonWrap button[type=submit]").text("Request your cloud scan");
		}, 5);
	});
}(jQuery, MktoForms2));